module.exports = __webpack_public_path__ + "static/media/pfSense_step2.ad6dc377.png";